import React from 'react';

import { PopupEntryPoint } from '../shared/popup-entry-point';
import { entryPoint } from './collectionAddPaymentDetailsPopup.entrypoint';
import { DIALOG_CONFIG } from './dialog-config';

export const CollectionAddPaymentDetailsPopup = (): React.JSX.Element => {
	return (
		<PopupEntryPoint
			entryPoint={entryPoint}
			entryPointProps={{}}
			placement={'bottom-end'}
			dialogConfig={DIALOG_CONFIG}
		/>
	);
};
